<app-app-page-title [title]="'Galéria'" [imgPath]="'assets/outside/5.jpg'"></app-app-page-title>

<app-gallery-header></app-gallery-header>

<router-outlet></router-outlet>
